import moment from 'moment';
import isFunction from 'lodash/isFunction';
import * as I18n from 'circe/I18n';
import uuid from 'uuid/v4';

export const formatPickupDeliveryDetails = (rawDetails) => {
  let details = rawDetails;
  if (rawDetails && rawDetails.stops) {
    details = rawDetails.stops[0];
  }
  const defaultFormattedDetails = {
    name: '',
    date: details ? details.pickupDate : 0, // Need to be changed
    address: '',
    location: { lat: 0, lng: 0 },
    contact: '',
    phone: '',
  };

  if (details && details.address) {
    let locationDetails;
    try {
      locationDetails = {
        lat: details.address[0].geometry.location.lat,
        lng: details.address[0].geometry.location.lng,
      };
      if (isFunction(details.address[0].geometry.location.lat)) {
        locationDetails.lat = details.address[0].geometry.location.lat();
        locationDetails.lng = details.address[0].geometry.location.lng();
      }
    } catch (e) {
      locationDetails = { lat: 0, lng: 0 };
    }

    // Location label
    let locationLabel = '';
    if (details.locationName && details.locationName.label) {
      locationLabel = details.locationName.label;
    } else if (details.address && details.address[0] && details.address[0].formatted_address) {
      locationLabel = details.address[0].formatted_address;
    }

    return {
      ...defaultFormattedDetails,
      name: locationLabel,
      date: details.pickupDate, // Need to be changed
      address: details.address[0].formatted_address,
      location: locationDetails,
      contact: details.contact,
      phone: details.phone,
    };
  }
  return defaultFormattedDetails;
};

/**
 * NEEDS REFACTORING
 * @param {*} values
 * @param {*} state
 */
export const formatSearchSummary = (values, state) => {
  const categoryId = values.category;
  const category = state.app.order.categories[categoryId];

  const capacity = category.childs.filter((child) => child._id === values.load[0].item)[0].weight
    .value;

  const summary = values.load.reduce(
    (summary, item) => {
      const quantity = parseInt(item.quantity);
      // Should be changed
      let weight = 1000;
      let width = 120;
      let height = 100;
      let length = 180;
      if (item.predefined) {
        weight = item.weight;
        height = item.height;
        length = item.length;
        width = item.width;
      }
      const currentWeight = weight * quantity;
      const currentVolume = (height * length * width * quantity) / 1000000;
      summary.weight.value += currentWeight;
      summary.volume.value += currentVolume;

      const currentItem = category.childs.filter((child) => item.item === child._id)[0];
      const { name, icon, price } = currentItem;
      const itemLine = {
        quantity,
        volume: `${currentVolume} CBM`,
        weight: `${currentWeight} KG`,
        // icon:require(`mdi-react/${icon}`).default,
        title: name,
      };
      summary.items.push(itemLine);
      return summary;
    },
    {
      weight: {
        value: 0,
        unit: 'KG',
      },
      volume: {
        value: 0,
        unit: 'CBM',
      },
      items: [],
      price: 0,
    },
  );

  summary.pickup = formatPickupDeliveryDetails(values.pickup);
  summary.delivery = formatPickupDeliveryDetails(values.delivery);

  summary.categoryId = categoryId;
  summary.volume.value = parseFloat(summary.volume.value.toFixed(2));

  let deliveryLoad = {
    description: '',
    unitOfMeasure: '',
    unitOfMeasureDescription: '',
    quantity: '',
  };
  if (values.delivery.stops[0] && values.delivery.stops[0].deliveryLoad) {
    deliveryLoad = {
      ...deliveryLoad,
      ...values.delivery.stops[0].deliveryLoad,
    };
  }

  summary.shipperId = values.shipperId;
  summary.shipmentValue = deliveryLoad.shipmentValue;
  summary.shipmentDescription = deliveryLoad.description;
  summary.itemUnitOfMeasure = deliveryLoad.unitOfMeasure;
  summary.itemQuantity = deliveryLoad.unitOfMeasure === 'Other'
    ? deliveryLoad.unitOfMeasureDescription
    : deliveryLoad.quantity;
  summary.truckCapacity = capacity;
  summary.truckType = categoryId;
  return summary;
};

export const formatResults = (results) => {
  if (results && results.quotes === undefined) {
    return [];
  }

  return results.quotes.map((quotes) => ({
    id: uuid(),
    quoteId: quotes.quoteId,
    quotes: quotes.quotes.map((quote) => {
      const date = moment(quote.expectedDelivery);
      return {
        shipmentId: quote.shipmentId, // Tracking ID used accross all the system
        itineraryId: quote.itineraryId, // Might have mnore than one shipment
        driver: {
          ...quote.resources.driver,
          vehicle: quote.resources.vehicle,
        },
        expectedDelivery: {
          date: date.format('DD/MM/YYYY'),
          time: date.format('HH:mm'),
        },
        price: {
          amount: quote.invoice.salesInvoice.total,
          originalAmount: quote.invoice.salesInvoice.originalTotal,
          currency: quote.invoice.salesInvoice.currency,
        },
        policies: [
          {
            title: 'Title',
            content: 'Content',
          },
        ],
        fees: quote.invoice.salesInvoice.lineItems,
        leadEstimate: quote.leadEstimate,
      };
    }),
  }));
};

export const leadEstimateToString = (leadEstimate) => {
  if (!leadEstimate) {
    return I18n.str('np', 'Not Available');
  }
  const { meters, time } = leadEstimate;
  const leadDistance = parseFloat(meters / 1000).toFixed(2); // KM
  const leadDuration = formatDuration(time);
  return `${leadDuration} / ${leadDistance} km`;
};

const formatDuration = (time) => {
  const formattedDuration = [
    {
      value: Math.floor(moment.duration(time).asDays()),
      unit: 'days',
      label: 'days',
    },
    {
      value:
        Math.floor(moment.duration(time).asHours())
        - Math.floor(moment.duration(time).asDays()) * 24,
      unit: 'hours',
      label: 'hrs',
    },
    {
      value:
        Math.ceil(moment.duration(time).asMinutes())
        - Math.floor(moment.duration(time).asHours()) * 60,
      unit: 'minutes',
      label: 'mins',
    },
  ];

  return formattedDuration
    .reduce((string, durations) => {
      if (durations.value >= 1) {
        string.push(`${durations.value} ${durations.label}`);
      }
      return string;
    }, [])
    .join(', ');
};
